import { useEffect } from 'react';
import {
    useLocation,
    useNavigate,
    useParams
  } from "react-router-dom";

export const withBADefaultRoute = (Component) =>  {
    const WithBADefaultRouteWrapper = (props) => {
		const location = useLocation();
		const navigate = useNavigate();
		const params = useParams();
		const match = {
			path: location.pathname
		};
		
		useEffect(() => {
			// if the default page has been requested
			var defaultRegex = /\/buildingaccess$/i;
			if (defaultRegex.test(match.path)) {
				if (props.user.isDelegate || props.user.isFSA || props.user.isPI || props.user.isSAO || props.user.isSupervisor) {
					navigate('/BuildingAccess/MyRequests');
				} else {
					navigate('/BuildingAccess/MyRecord');
				}
			}
		});
		
		return (
			<Component
				location={location}
				navigate={navigate}
				params={params}
				match={match}
				{...props}
			/>
		);
    }
    return WithBADefaultRouteWrapper;
}
